import { useMemo } from 'react'

import { useProcessFilter } from 'features/records/components/RecordFilters'
import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

export function useRecordSupportsEditing() {
    const { view, isEditing } = useLayoutEditorContext()
    const { record, isLoading } = useRecordManagerContext()

    const editingMode = view?.layout?.editingMode ?? 'inline'

    const processFilter = useProcessFilter()
    const conditionsAllowEditing = useMemo(() => {
        if (!record || !view || isLoading) return false

        const allowEditingModeConditions = view?.layout?.allowEditingModeConditions ?? []

        if (!allowEditingModeConditions.length) return true

        return processFilter([record], allowEditingModeConditions).length > 0
    }, [isLoading, processFilter, record, view])
    const supportsEditing =
        !isLoading && !!record && editingMode !== 'disabled' && !isEditing && conditionsAllowEditing

    return supportsEditing
}
